module.exports = __webpack_public_path__ + "static/media/template6.06752251.png";